import {
  Button,
  Icons,
  LinkButton,
  TextArea,
  TextField,
} from "@flash-tecnologia/hros-web-ui-v2";
import { Box } from "src/components/core-components/atoms/Box/box";
import { Drawer } from "src/components/core-components/organisms/Drawer/drawer";
import { useCreateJobRoleDrawer } from "../../hooks/use-create-job-role-drawer";
import { JobRole } from "../../types";

interface CreateJobRoleDrawerProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (jobRole: JobRole) => void;
}

export const CreateJobRoleDrawer = ({
  onClose,
  onSuccess,
  open,
}: CreateJobRoleDrawerProps) => {
  const {
    cbo,
    cboError,
    description,
    isLoading,
    name,
    nameError,
    onCboBlur,
    onCboChange,
    onDescriptionChange,
    onDrawerClose,
    onDrawerSubmit,
    onFindCboClick,
    onNameBlur,
    onNameChange,
  } = useCreateJobRoleDrawer({
    onClose,
    onSuccess,
  });

  return (
    <Drawer
      title="Novo cargo"
      subtitle={"Adicione as informações a seguir para criar um cargo"}
      open={open}
      onClose={onDrawerClose}
    >
      <Box flexDirection="column" gap="xs" $height="100%" $pb="xs">
        <Box flex={1} flexDirection="column" gap="xs2">
          <div>
            <TextField
              fullWidth
              onBlur={onNameBlur}
              onChange={(event) => onNameChange(event.target.value)}
              label={"Nome do cargo*"}
              error={!!nameError}
              helperText={nameError}
              value={name}
            />
          </div>
          <TextArea
            placeholder={"Adicione uma descrição"}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
              onDescriptionChange(event.target.value)
            }
            height={100}
            maxLength={100}
            value={description}
          />
          <div>
            <TextField
              fullWidth
              onBlur={onCboBlur}
              onChange={(event) => onCboChange(event.target.value)}
              label={"Código CBO*"}
              error={!!cboError}
              helperText={cboError}
              value={cbo}
            />
          </div>
          <Box>
            <LinkButton
              variant="neutral"
              size="medium"
              onClick={onFindCboClick}
              underlined={false}
            >
              Buscar código CBO por título{" "}
              <Icons name="IconExternalLink" size={16} />
            </LinkButton>
          </Box>
        </Box>
        <Box $width="100%" justifyContent="flex-end">
          <Button
            loading={isLoading}
            variant="primary"
            onClick={onDrawerSubmit}
          >
            Criar
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
